import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class RoomTypeService {

    static getroomType(item) {

        let api = `${API_BASE_URL}${API_PATHS.getroomType}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.hotelId) params.append("hotelId", item.hotelId);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addroomType(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addroomType}`;
        return axiosInstance
            .post(api, data)

    }

    static editroomType(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editroomType}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteroomType(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteroomType}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default RoomTypeService;
